import { Modal } from 'src/components/Common/@electron/Modal';
import { CarolinasJurisdictionModalInterface } from '../../../types';
import CarolinasJurisdictionSelectCards from './components/CarolinasJurisdictionSelectCards';

const CarolinasJurisdictionModal = ({
  title,
  titleVariant,
  description,
  id,
  isOpen,
  variant,
  stateCode,
  setRegionSelectModalIsOpen,
  setJurisdiction,
}: CarolinasJurisdictionModalInterface) => {
  return (
    <Modal
      title={title}
      titleVariant={titleVariant}
      description={description}
      id={id}
      isOpen={isOpen}
      variant={variant}
    >
      <CarolinasJurisdictionSelectCards
        stateCode={stateCode}
        setRegionSelectModalIsOpen={setRegionSelectModalIsOpen}
        setJurisdiction={setJurisdiction}
      />
    </Modal>
  );
};

export default CarolinasJurisdictionModal;
